import React from 'react';

import clsx from 'clsx';
import Link from 'next/link';

import useSubmenu from 'hooks/useSubmenu';
import Slash from 'ui/Icon/icons/Slash';

type BreadCrumbItem = {
  href: string;
  name: string;
  targetElement: string;
};

const BreadcrumbWrapper = ({
  navigationItems,
  subMenuName,
}: {
  navigationItems: BreadCrumbItem[];
  subMenuName?: string;
}) => {
  const { setSubmenuOpen } = useSubmenu();

  // upon clicking the submenu , open the submenu
  const handleClick = (breadcumb: string) => {
    if (subMenuName === breadcumb) {
      setSubmenuOpen(true);
    }
  };

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol role="list" className="flex flex-wrap items-center sm:space-x-4">
        {navigationItems.map((page, index) => (
          <li key={page.name}>
            <div className="flex items-center">
              {index > 0 && <Slash />}
              <Link
                href={page.href}
                onClick={() => handleClick(page.name)}
                className={clsx(
                  `${index > 0 ? 'ml-4' : ''}`,
                  'text-sm font-medium text-gray-500 hover:text-gray-700',
                )}
                aria-current={'page'}
              >
                {page.name}
              </Link>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadcrumbWrapper;
